/* src/app/layouts/shopping-summary/shopping-summary.component.css */
/*# sourceMappingURL=shopping-summary.component.css.map */
